<template>
  <section id="layout" class="l-contentmain contentmain"
           :class="{'is-min-height-full': isAdmin}">
    <router-view></router-view>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'Layout',
    computed: {
      ...mapGetters(['isAdmin']),
      isAdminDashboard () {
        return this.$route.name === 'Home' && this.isAdmin && !this.$route.query.map
      },
      maxHeight () {
        return 'maxHeight' in this.$route.meta && this.$route.meta.maxHeight === true
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/layout/Layout.vue